(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aromatherapy-hoodie-below-fold"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.aromatherapy-hoodie-below-fold').forEach((section) => {
      const stickyAtc = section.querySelector('[data-sticky-atc]');
      const stickyTitle = section.querySelector('[data-sticky-atc-title]');
      const stickyPrice = section.querySelector('[data-sticky-atc-price]');
      const stickyScrollButton = section.querySelector('[data-sticky-atc-scroll]');
      const studyModal = section.querySelector('[data-study-modal]');
      const studyContent = section.querySelector('[data-study-content]');
      const atfSection = document.querySelector('.aromatherapy-hoodie-product');
      const scentFieldset = document.querySelector('.aromatherapy-hoodie-product__option--scent');
      const productForm = document.querySelector('.aromatherapy-hoodie-product__form form[data-type="add-to-cart-form"]');
      const productSubmitButton = productForm?.querySelector('[name="add"]');
      const priceSource = document.querySelector('.aromatherapy-hoodie-product__price');
      let hasIntentionalScentSelection = new URL(window.location.href).searchParams.has('variant');

      const howOneData = [
        {
          title: 'Slide into the pocket',
          copy: `A discreet compartment along the hood's edge. Takes 5 seconds. Invisible to everyone else.`,
          image: `https://cdn.shopify.com/s/files/1/0714/5868/5233/files/flowering-pot-how-slide-pocket.png?v=1777330221`
        },
        {
          title: 'Inhale calm',
          copy: `The scent releases as you move. Breathe through your nose and let the aromatherapy work instantly.`,
          image: `https://cdn.shopify.com/s/files/1/0714/5868/5233/files/flowering-pot-how-inhale-calm.png?v=1777330221`
        },
        {
          title: 'Squeeze anytime',
          copy: `The built-in stress ball is always there. Discreetly squeeze whenever you need it. No one knows.`,
          image: `https://cdn.shopify.com/s/files/1/0714/5868/5233/files/flowering-pot-how-squeeze-anytime.png?v=1777330222`
        }
      ];

      const studyData = {
        cortisol: {
          title: '69% Cortisol Reduction',
          kicker: 'Pre-Surgical Anxiety Study',
          copy: 'Patients exposed to lavender aroma before surgery experienced significant decreases in anxiety scores and up to 69% reduction in cortisol (stress hormone) levels.',
          meta: 'Source: PubMed · PMID: 27563324',
          link: 'https://pubmed.ncbi.nlm.nih.gov/27563324/'
        },
        meta: {
          title: '21 Studies Meta-Analysis',
          kicker: 'Systematic Review of Lavender Aromatherapy',
          copy: 'Combined data from 21 peer-reviewed studies found a statistically significant decrease in stress levels after lavender use. This represents the strongest form of clinical evidence.',
          meta: 'Source: Complementary Therapies in Clinical Practice, 2022',
          link: 'https://www.sciencedirect.com/science/article/pii/S0965229922000346'
        },
        participants: {
          title: '1,500+ Participants',
          kicker: 'Across Multiple Clinical Trials',
          copy: 'Over 1,500 participants across 21 peer-reviewed studies showed consistent, measurable stress reduction with lavender aromatherapy exposure.',
          meta: 'Source: Meta-analysis summary',
          link: 'https://www.sciencedirect.com/science/article/pii/S0965229922000346'
        }
      };

      const readCheckedValue = (selector) => {
        const input = document.querySelector(`${selector} input[type="radio"]:checked`);
        return input ? input.value : '';
      };

      const scrollToScentSelector = () => {
        const scrollTarget = scentFieldset || atfSection;
        if (scrollTarget) {
          scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      };

      const submitProductForm = () => {
        if (!productForm || !productSubmitButton || productSubmitButton.disabled) return;

        if (typeof productForm.requestSubmit === 'function') {
          productForm.requestSubmit(productSubmitButton);
        } else {
          productSubmitButton.click();
        }
      };

      const syncStickyAtc = () => {
        if (!stickyTitle) return;

        const scent = readCheckedValue('.aromatherapy-hoodie-product__option--scent');
        const size = readCheckedValue('.aromatherapy-hoodie-product__option--size');
        const color = readCheckedValue('.aromatherapy-hoodie-product__option--color');
        const productTitle = section.dataset.productTitle || 'Aromatherapy Hoodie';
        const variantDetails = [scent, size, color].filter(Boolean).join(' / ');
        const canAddFromSticky = Boolean(hasIntentionalScentSelection && scent);

        stickyTitle.textContent = canAddFromSticky && variantDetails ? variantDetails : productTitle;

        if (stickyScrollButton) {
          stickyScrollButton.textContent = canAddFromSticky ? 'Add to Cart' : 'Select Scent';
          stickyScrollButton.setAttribute('aria-label', canAddFromSticky && variantDetails ? `Add ${productTitle}: ${variantDetails} to cart` : 'Select a scent before adding to cart');
        }

        if (stickyAtc) {
          stickyAtc.classList.toggle('is-addable', canAddFromSticky);
        }

        if (priceSource && stickyPrice) {
          stickyPrice.innerHTML = priceSource.innerHTML;
        }
      };

      const closeStudyModal = () => {
        if (!studyModal) return;
        studyModal.hidden = true;
        document.body.style.overflow = '';
      };

      const openStudyModal = (key) => {
        const data = studyData[key];
        if (!studyModal || !studyContent || !data) return;

        studyContent.innerHTML = `
          <h3>${data.title}</h3>
          <p class="aromatherapy-hoodie-below-fold__study-kicker">${data.kicker}</p>
          <p class="aromatherapy-hoodie-below-fold__study-copy">${data.copy}</p>
          <p class="aromatherapy-hoodie-below-fold__study-meta">${data.meta}</p>
          <a class="aromatherapy-hoodie-below-fold__study-link" href="${data.link}" target="_blank" rel="noopener">View study →</a>
        `;

        studyModal.hidden = false;
        document.body.style.overflow = 'hidden';
      };

      const initHowOne = () => {
        const root = section.querySelector('[data-how-one]');
        if (!root) return;

        const track = root.querySelector('[data-how-one-track]');
        const cards = Array.from(root.querySelectorAll('[data-how-one-card]'));
        const dots = root.querySelector('[data-how-one-dots]');
        const next = root.querySelector('[data-how-one-next]');
        const count = root.querySelector('[data-how-one-count]');
        const label = root.querySelector('[data-how-one-label]');
        const stageNumber = root.querySelector('[data-how-one-stage-number]');
        const stageImage = root.querySelector('[data-how-one-stage-image]');
        const stageTitle = root.querySelector('[data-how-one-stage-title]');
        const stageCopy = root.querySelector('[data-how-one-stage-copy]');
        const tabs = Array.from(root.querySelectorAll('[data-how-one-tab]'));
        let activeIndex = 0;
        let isProgrammaticScroll = false;
        let scrollSettleTimer = null;
        let scrollRaf = null;
        let motionBlurTimer = null;
        let lastScrollLeft = track ? track.scrollLeft : 0;
        let lastScrollTime = performance.now();
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        const render = (index) => {
          activeIndex = Math.max(0, Math.min(howOneData.length - 1, index));
          const data = howOneData[activeIndex];

          if (count) count.textContent = `${activeIndex + 1} / ${howOneData.length}`;
          if (label) label.textContent = data.title;
          if (stageNumber) stageNumber.textContent = activeIndex + 1;
          if (stageImage) stageImage.style.setProperty('--how-one-image', `url('${data.image}')`);
          if (stageTitle) stageTitle.textContent = data.title;
          if (stageCopy) stageCopy.textContent = data.copy;

          tabs.forEach((tab, tabIndex) => tab.classList.toggle('is-active', tabIndex === activeIndex));
          if (dots) {
            dots.querySelectorAll('span').forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === activeIndex));
          }
        };

        if (dots && !dots.children.length) {
          howOneData.forEach(() => dots.appendChild(document.createElement('span')));
        }

        tabs.forEach((tab) => {
          tab.addEventListener('click', () => render(Number(tab.dataset.index || 0)));
        });

        const resetMotionBlur = () => {
          if (!track) return;
          track.style.setProperty('--how-one-motion-blur', '0px');
          track.classList.remove('is-motion-blurring');
        };

        const updateMotionBlur = () => {
          if (!track || reduceMotion.matches) return;

          const now = performance.now();
          const elapsed = Math.max(16, now - lastScrollTime);
          const distance = Math.abs(track.scrollLeft - lastScrollLeft);
          const velocity = distance / elapsed;
          const blur = Math.min(1.15, velocity * 1.05);

          lastScrollLeft = track.scrollLeft;
          lastScrollTime = now;

          if (blur < 0.08) return;

          track.classList.add('is-motion-blurring');
          track.style.setProperty('--how-one-motion-blur', `${blur.toFixed(2)}px`);
          window.clearTimeout(motionBlurTimer);
          motionBlurTimer = window.setTimeout(resetMotionBlur, 140);
        };

        const getCenteredScrollLeft = (card) => card.offsetLeft - ((track.clientWidth - card.clientWidth) / 2);

        if (next && track) {
          next.addEventListener('click', () => {
            const nextIndex = (activeIndex + 1) % cards.length;
            const targetCard = cards[nextIndex];
            if (!targetCard) return;

            isProgrammaticScroll = true;
            window.clearTimeout(scrollSettleTimer);
            track.scrollTo({ left: getCenteredScrollLeft(targetCard), behavior: 'smooth' });
            render(nextIndex);

            scrollSettleTimer = window.setTimeout(() => {
              isProgrammaticScroll = false;
            }, 520);
          });
        }

        if (track && cards.length) {
          track.addEventListener('scroll', () => {
            updateMotionBlur();
            if (isProgrammaticScroll || scrollRaf) return;

            scrollRaf = window.requestAnimationFrame(() => {
              scrollRaf = null;
              const trackCenter = track.scrollLeft + track.clientWidth / 2;
              const closest = cards.reduce((best, card, index) => {
                const cardCenter = card.offsetLeft + card.clientWidth / 2;
                const distance = Math.abs(cardCenter - trackCenter);
                return distance < best.distance ? { index, distance } : best;
              }, { index: activeIndex, distance: Infinity });

              if (closest.index !== activeIndex) render(closest.index);
            });
          }, { passive: true });

          track.addEventListener('scrollend', () => {
            isProgrammaticScroll = false;
            resetMotionBlur();
          }, { passive: true });
        }

        render(0);
      };

      initHowOne();

      /* ---------- Review Slider ---------- */
      const initReviewSlider = () => {
        const root = section.querySelector('[data-review-slider]');
        if (!root) return;

        const track = root.querySelector('[data-review-track]');
        const prevBtn = root.querySelector('[data-review-slider-prev]');
        const nextBtn = root.querySelector('[data-review-slider-next]');
        const dotsContainer = root.querySelector('[data-review-slider-dots]');
        const cards = Array.from(track.querySelectorAll('.aromatherapy-hoodie-below-fold__review-card'));
        if (!cards.length) return;

        let currentIndex = 0;

        /* Calculate how many cards fit in the visible track width */
        const getStepSize = () => {
          if (!cards.length) return 1;
          const trackGap = parseFloat(window.getComputedStyle(track).columnGap) || parseFloat(window.getComputedStyle(track).gap) || 0;
          const cardOuterWidth = cards[0].offsetWidth + trackGap;
          const visibleCards = Math.round(track.clientWidth / cardOuterWidth);
          /* Step by 1 card at a time, but cap maxIndex so the last page is fully visible */
          return 1;
        };

        const getMaxIndex = () => {
          if (!cards.length) return 0;
          const trackGap = parseFloat(window.getComputedStyle(track).columnGap) || parseFloat(window.getComputedStyle(track).gap) || 0;
          const cardOuterWidth = cards[0].offsetWidth + trackGap;
          const visibleCards = Math.round(track.clientWidth / cardOuterWidth);
          return Math.max(0, cards.length - visibleCards);
        };

        /* Build page-based dots: one dot per scroll position (maxIndex + 1) */
        const buildDots = () => {
          if (!dotsContainer) return;
          dotsContainer.innerHTML = '';
          const pageCount = getMaxIndex() + 1;
          for (let i = 0; i < pageCount; i++) {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'aromatherapy-hoodie-below-fold__review-slider-dot' + (i === currentIndex ? ' is-active' : '');
            dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
            dot.addEventListener('click', () => scrollToIndex(i));
            dotsContainer.appendChild(dot);
          }
        };

        const scrollToIndex = (index) => {
          const maxIndex = getMaxIndex();
          currentIndex = Math.max(0, Math.min(index, maxIndex));

          /* Scroll so the card at currentIndex is the leftmost visible card */
          const trackGap = parseFloat(window.getComputedStyle(track).columnGap) || parseFloat(window.getComputedStyle(track).gap) || 0;
          const cardOuterWidth = cards[0].offsetWidth + trackGap;
          track.scrollTo({ left: currentIndex * cardOuterWidth, behavior: 'smooth' });

          /* Update dots */
          if (dotsContainer) {
            dotsContainer.querySelectorAll('.aromatherapy-hoodie-below-fold__review-slider-dot').forEach((dot, i) => {
              dot.classList.toggle('is-active', i === currentIndex);
            });
          }

          /* Update button states */
          if (prevBtn) prevBtn.disabled = currentIndex === 0;
          if (nextBtn) nextBtn.disabled = currentIndex >= maxIndex;
        };

        buildDots();
        scrollToIndex(0);

        if (prevBtn) prevBtn.addEventListener('click', () => scrollToIndex(currentIndex - 1));
        if (nextBtn) nextBtn.addEventListener('click', () => scrollToIndex(currentIndex + 1));

        /* Sync dot state on manual scroll / drag */
        let scrollTimeout;
        track.addEventListener('scroll', () => {
          clearTimeout(scrollTimeout);
          scrollTimeout = setTimeout(() => {
            const trackGap = parseFloat(window.getComputedStyle(track).columnGap) || parseFloat(window.getComputedStyle(track).gap) || 0;
            const cardOuterWidth = cards[0].offsetWidth + trackGap;
            const nearest = Math.round(track.scrollLeft / (cardOuterWidth || 1));
            const maxIndex = getMaxIndex();
            currentIndex = Math.max(0, Math.min(nearest, maxIndex));
            if (dotsContainer) {
              dotsContainer.querySelectorAll('.aromatherapy-hoodie-below-fold__review-slider-dot').forEach((dot, i) => {
                dot.classList.toggle('is-active', i === currentIndex);
              });
            }
            if (prevBtn) prevBtn.disabled = currentIndex === 0;
            if (nextBtn) nextBtn.disabled = currentIndex >= maxIndex;
          }, 80);
        }, { passive: true });

        /* Rebuild dots on resize so the count matches the new maxIndex */
        let resizeTimeout;
        window.addEventListener('resize', () => {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(() => {
            const maxIndex = getMaxIndex();
            currentIndex = Math.min(currentIndex, maxIndex);
            buildDots();
            scrollToIndex(currentIndex);
          }, 150);
        });
      };

      initReviewSlider();

      const initCountUp = () => {
        const numbers = Array.from(section.querySelectorAll('[data-count-up]'));
        if (!numbers.length) return;

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const formatNumber = (value) => Math.round(value).toLocaleString('en-US');
        const renderNumber = (element, value) => {
          const suffix = element.dataset.countSuffix || '';
          element.textContent = `${formatNumber(value)}${suffix}`;
        };

        const animateNumber = (element) => {
          if (element.dataset.countAnimated === 'true') return;
          element.dataset.countAnimated = 'true';

          const target = Number(element.dataset.countTarget || 0);
          if (!target || reduceMotion) {
            renderNumber(element, target);
            return;
          }

          const duration = 950;
          const startTime = performance.now();

          const tick = (now) => {
            const progress = Math.min((now - startTime) / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            renderNumber(element, target * eased);

            if (progress < 1) {
              window.requestAnimationFrame(tick);
            } else {
              renderNumber(element, target);
            }
          };

          renderNumber(element, 0);
          window.requestAnimationFrame(tick);
        };

        if (!('IntersectionObserver' in window)) {
          numbers.forEach(animateNumber);
          return;
        }

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            animateNumber(entry.target);
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.45 });

        numbers.forEach((number) => observer.observe(number));
      };

      initCountUp();

      section.querySelectorAll('[data-study-trigger]').forEach((card) => {
        card.addEventListener('click', () => openStudyModal(card.dataset.studyTrigger));
      });

      section.querySelectorAll('[data-study-close]').forEach((button) => {
        button.addEventListener('click', closeStudyModal);
      });

      if (stickyScrollButton) {
        stickyScrollButton.addEventListener('click', () => {
          const scent = readCheckedValue('.aromatherapy-hoodie-product__option--scent');

          if (hasIntentionalScentSelection && scent) {
            submitProductForm();
            return;
          }

          scrollToScentSelector();
        });
      }

      if (atfSection && stickyAtc) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            stickyAtc.classList.toggle('is-visible', !entry.isIntersecting);
          });
        }, { threshold: 0 });

        observer.observe(atfSection);
      }

      document.querySelectorAll('.aromatherapy-hoodie-product__option input[type="radio"]').forEach((input) => {
        input.addEventListener('change', () => {
          if (input.closest('.aromatherapy-hoodie-product__option--scent')) {
            hasIntentionalScentSelection = true;
          }

          syncStickyAtc();
        });
      });

      document.querySelectorAll('.aromatherapy-hoodie-product__option--scent input[type="radio"]').forEach((input) => {
        input.addEventListener('click', () => {
          hasIntentionalScentSelection = true;
          syncStickyAtc();
        });
      });

      if (priceSource) {
        const priceObserver = new MutationObserver(syncStickyAtc);
        priceObserver.observe(priceSource, { childList: true, subtree: true, characterData: true });
      }

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && studyModal && !studyModal.hidden) {
          closeStudyModal();
        }
      });

      syncStickyAtc();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-aromatherapy-hoodie"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.aromatherapy-hoodie-product').forEach((section) => {
      const quantityInput = section.querySelector('.aromatherapy-hoodie-product__qty-input');
      section.querySelectorAll('[data-qty]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!quantityInput) return;
          const currentValue = Number(quantityInput.value || 1);
          const nextValue = button.dataset.qty === 'plus' ? currentValue + 1 : Math.max(1, currentValue - 1);
          quantityInput.value = String(nextValue);
        });
      });

      const scentModal = section.querySelector('[data-scent-modal]');
      const scentModalName = section.querySelector('[data-scent-modal-name]');
      const scentModalTagline = section.querySelector('[data-scent-modal-tagline]');
      const scentModalContent = section.querySelector('[data-scent-modal-content]');
      const scentModalSelect = section.querySelector('[data-scent-modal-select]');
      const scentModalDialog = section.querySelector('.aromatherapy-hoodie-product__scent-modal-dialog');
      const scentModalIcon = section.querySelector('[data-scent-modal-icon]');
      const fitGuideModal = section.querySelector('[data-fit-guide-modal]');
      const fitGuideTabs = section.querySelectorAll('.aromatherapy-hoodie-product__fit-guide-modal [data-size-guide-tab]');
      const fitGuideContents = section.querySelectorAll('.aromatherapy-hoodie-product__fit-guide-modal [data-size-guide-content]');

      const updateFitGuideTab = (tabName = 'inches') => {
        fitGuideContents.forEach((content) => {
          content.style.display = content.dataset.sizeGuideContent === tabName ? 'block' : 'none';
        });
        fitGuideTabs.forEach((tab) => {
          tab.classList.toggle('active', tab.dataset.sizeGuideTab === tabName);
        });
      };

      fitGuideTabs.forEach((tab) => {
        tab.addEventListener('click', () => updateFitGuideTab(tab.dataset.sizeGuideTab));
      });

      let activeScentRadioId = '';

      const closeScentModal = () => {
        if (!scentModal) return;
        scentModal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        activeScentRadioId = '';
      };

      const openScentModal = (radio) => {
        if (!scentModal || !scentModalName || !scentModalTagline || !scentModalContent || !radio) return;
        // Move the modal out of the product section so it can cover sticky headers,
        // announcement bars, app embeds, and any section-level stacking contexts.
        if (scentModal.parentElement !== document.body) {
          document.body.appendChild(scentModal);
        }
        
        scentModalName.textContent = radio.dataset.scentName || '';
        scentModalTagline.textContent = radio.dataset.scentTagline || '';
        if (radio.dataset.scentAccent) {
          [scentModal, scentModalDialog].forEach((element) => {
            if (element) element.style.setProperty('--scent-accent', radio.dataset.scentAccent);
          });
        }
        if (radio.dataset.scentTint) {
          [scentModal, scentModalDialog].forEach((element) => {
            if (element) element.style.setProperty('--scent-tint', radio.dataset.scentTint);
          });
        }
        if (scentModalIcon && radio.dataset.scentIcon) {
          scentModalIcon.src = radio.dataset.scentIcon;
        }

        const parts = [];
        if (radio.dataset.scentDescriptor) parts.push(`<p><strong>What it is:</strong> ${radio.dataset.scentDescriptor}</p>`);
        if (radio.dataset.scentNotes) parts.push(`<p><strong>Scent notes:</strong> ${radio.dataset.scentNotes}</p>`);
        if (radio.dataset.scentBestFor) parts.push(`<p><strong>Best for:</strong> ${radio.dataset.scentBestFor}</p>`);
        if (radio.dataset.scentIngredients) parts.push(`<p><strong>Ingredients:</strong> ${radio.dataset.scentIngredients}</p>`);
        if (radio.dataset.scentCompounds) parts.push(`<p><strong>Key compounds:</strong> ${radio.dataset.scentCompounds}</p>`);
        if (radio.dataset.scentWarning) parts.push(`<p><strong>Note:</strong> ${radio.dataset.scentWarning}</p>`);
        scentModalContent.innerHTML = parts.join('');

        scentModal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      };

      section.querySelectorAll('[data-scent-learn]').forEach((button) => {
        button.addEventListener('click', () => {
          const radio = section.querySelector(`#${CSS.escape(button.dataset.scentLearn)}`);
          if (radio) openScentModal(radio);
        });
      });

      section.querySelectorAll('[data-scent-learn-selected]').forEach((button) => {
        button.addEventListener('click', () => {
          const radio = section.querySelector('.aromatherapy-hoodie-product__option--scent .aromatherapy-hoodie-product__radio-input:checked');
          if (radio) openScentModal(radio);
        });
      });

      section.querySelectorAll('[data-scent-modal-close]').forEach((button) => {
        button.addEventListener('click', closeScentModal);
      });

      const closeFitGuideModal = () => {
        if (!fitGuideModal) return;
        fitGuideModal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      };

      const openFitGuideModal = () => {
        if (!fitGuideModal) return;
        // Move the fit guide to <body> before showing it so its huge z-index is
        // compared against the whole page, not trapped inside the product form's
        // stacking context where the sticky header can visually compete with it.
        if (fitGuideModal.parentElement !== document.body) {
          document.body.appendChild(fitGuideModal);
        }
        fitGuideModal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      };

      section.querySelectorAll('[data-fit-guide-open]').forEach((button) => {
        button.addEventListener('click', openFitGuideModal);
      });

      section.querySelectorAll('[data-fit-guide-close]').forEach((button) => {
        button.addEventListener('click', closeFitGuideModal);
      });

      if (scentModalSelect) {
        scentModalSelect.addEventListener('click', () => {
          closeScentModal();
        });
      }

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && scentModal && scentModal.getAttribute('aria-hidden') === 'false') {
          closeScentModal();
        }
        if (event.key === 'Escape' && fitGuideModal && fitGuideModal.getAttribute('aria-hidden') === 'false') {
          closeFitGuideModal();
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
